// Generated file : do not modify
export enum MetaAttribTypes
{
  NONE = 0,
  INT,
  DECIMAL,
  CURRENCY,
  STRING,
  DATE
};

import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Meta-attributs
export class MetaValue {
  // Nom du meta-attribut
  public name: string;
  // Id du meta-attribut
  public metaAttributId: number;
  // JSON de la valeur du meta-attribut
  public value: string;

  constructor() {
    this.name = '';
    this.metaAttributId = 0;
    this.value = '';
  }
}

export class MetaTag {
  // Id du meta-attribut
  public metaAttributId: number;
  // Classe
  public classe: string;
  // Objet valorisé dans la classe
  public classeId: number;

  constructor() {
    this.metaAttributId = 0;
    this.classe = '';
    this.classeId = 0;
  }
}

export default class MetaAttrib  {
  // Identifiant unique
  public id: number;
  // Nom (chemin d'accès)
  public name: string;
  // Texte de substitution
  public text: string;
  // Question
  public question: string;
  // Type
  public type: MetaAttribTypes;
  // Classe
  public classe: string;
  // Template contrat
  public contratTemplateId: number;
  // Conventions applicables (vide = toutes)
  public conventionIds: number[];
  // Emplois applicables (vide = tous)
  public emploiIds: number[];
  // Objet valorisé dans la classe
  public classeId: number;
  // Document objType
  public docObjType: ObjTypes;
  // Document objId
  public docObjId: number;
  // Chemin
  public path: string;
  // Chemins possibles
  public paths: string[];
  // JSON de la valeur du meta-attribut
  public value: string;
  // Pour filtrer les dialogues
  public displayed: boolean;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.name = '';
    this.text = '';
    this.question = '';
    this.type = MetaAttribTypes.NONE;
    this.classe = '';
    this.contratTemplateId = 0;
    this.conventionIds = [];
    this.emploiIds = [];
    this.classeId = 0;
    this.docObjType = ObjTypes.NONE;
    this.docObjId = 0;
    this.path = '';
    this.paths = [];
    this.value = '';
    this.displayed = false;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: MetaAttrib): MetaAttrib {
    const newMetaAttrib: MetaAttrib = new MetaAttrib();
    newMetaAttrib.id = obj.id;
    newMetaAttrib.name = obj.name;
    newMetaAttrib.text = obj.text;
    newMetaAttrib.question = obj.question;
    newMetaAttrib.type = obj.type;
    newMetaAttrib.classe = obj.classe;
    newMetaAttrib.contratTemplateId = obj.contratTemplateId;
    newMetaAttrib.conventionIds = JSON.parse(JSON.stringify(obj.conventionIds));
    newMetaAttrib.emploiIds = JSON.parse(JSON.stringify(obj.emploiIds));
    newMetaAttrib.classeId = obj.classeId;
    newMetaAttrib.docObjType = obj.docObjType;
    newMetaAttrib.docObjId = obj.docObjId;
    newMetaAttrib.path = obj.path;
    newMetaAttrib.paths = JSON.parse(JSON.stringify(obj.paths));
    newMetaAttrib.value = obj.value;
    newMetaAttrib.displayed = obj.displayed;
    newMetaAttrib.createId = obj.createId;
    newMetaAttrib.failed = obj.failed;
    newMetaAttrib.canUpdate = obj.canUpdate;
    newMetaAttrib.canDelete = obj.canDelete;
    newMetaAttrib.display = obj.display;
    newMetaAttrib.notifDefType = obj.notifDefType;
    return newMetaAttrib;
  }

  public toJsonMetaAttrib (): string {
    const json = {
      name: this.name,
      text: this.text,
      question: this.question,
      type: this.type,
      classe: this.classe,
      contratTemplateId: this.contratTemplateId,
      conventionIds: this.conventionIds,
      emploiIds: this.emploiIds,
      classeId: this.classeId,
      docObjType: this.docObjType,
      docObjId: this.docObjId,
      path: this.path,
      paths: this.paths,
      value: this.value,
      displayed: this.displayed,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromMetaAttrib (obj: MetaAttrib): void {
    this.id = obj.id;
    this.name = obj.name;
    this.text = obj.text;
    this.question = obj.question;
    this.type = obj.type;
    this.classe = obj.classe;
    this.contratTemplateId = obj.contratTemplateId;
    this.conventionIds = obj.conventionIds;
    this.emploiIds = obj.emploiIds;
    this.classeId = obj.classeId;
    this.docObjType = obj.docObjType;
    this.docObjId = obj.docObjId;
    this.path = obj.path;
    this.paths = obj.paths;
    this.value = obj.value;
    this.displayed = obj.displayed;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareMetaAttrib (value: MetaAttrib): boolean {
    return (this.toJsonMetaAttrib() == value.toJsonMetaAttrib());
  }

  public cloneMetaAttrib (): MetaAttrib {
    return MetaAttrib.fromJson(this);
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/metaattribs/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static define (metaAttrib: MetaAttrib): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/metaattribs/define', metaAttrib, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static valuate (metaAttribs: MetaAttrib[]): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/metaattribs/valuate', metaAttribs, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/MetaAttribs/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = MetaAttrib.fromJson(listData.reccords[0] as MetaAttrib);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<MetaAttrib> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/MetaAttribs/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = MetaAttrib.fromJson(listData.reccords[0] as MetaAttrib);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(metaAttribs: MetaAttrib[]) {
  }
}
